import React, { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../css/toast-overrides.css';
import '../../sass/style.scss';
import AllRoute from "../router/index.js"
import '../App/whatsapp-widget.css' 

const App = () => {
  const [isWhatsAppOpen, setIsWhatsAppOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [userPhone, setUserPhone] = useState('');
  const [userName, setUserName] = useState('');

  const handleWhatsAppSubmit = (e) => {
    e.preventDefault();

    if (!message.trim() || !userPhone.trim() || !userName.trim()) {
      alert('Please enter your name, phone number, and message.');
      return;
    }

    // Format the message for WhatsApp
    const formattedMessage = `*New Inquiry from Maakdream Website*

*Customer Name:* ${userName}
*Customer Phone:* ${userPhone}
*Message:* ${message}
*Time:* ${new Date().toLocaleString()}
*Source:* Website Contact Form

Please respond to this inquiry.`;

    // Create WhatsApp URL with the formatted message
    const whatsappUrl = `https://wa.me/971558690761?text=${encodeURIComponent(formattedMessage)}`;

    // Open WhatsApp in a new tab/window
    window.open(whatsappUrl, '_blank');

    // Reset form and close widget
    setMessage('');
    setUserPhone('');
    setUserName('');
    setIsWhatsAppOpen(false);
  };

  return (
    <div className="App" id='scrool'>
       
      <AllRoute />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        style={{ zIndex: 9999 }}
      />

      {/* Custom Floating WhatsApp Button */}
      <div className="floating-whatsapp-button" style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 1000,
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
      }}>

        {/* Floating Button */}
        <button
          onClick={() => setIsWhatsAppOpen(!isWhatsAppOpen)}
          style={{
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            backgroundColor: '#25D366',
            border: 'none',
            color: 'white',
            fontSize: '28px',
            cursor: 'pointer',
            boxShadow: '0 4px 12px rgba(37, 211, 102, 0.4)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.3s ease',
            position: 'relative'
          }}
          onMouseOver={(e) => {
            e.target.style.transform = 'scale(1.1)';
            e.target.style.boxShadow = '0 6px 20px rgba(37, 211, 102, 0.6)';
          }}
          onMouseOut={(e) => {
            e.target.style.transform = 'scale(1)';
            e.target.style.boxShadow = '0 4px 12px rgba(37, 211, 102, 0.4)';
          }}
        >
          {/* WhatsApp Icon */}
          <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" />
          </svg>
        </button>

        {/* Chat Widget */}
        {isWhatsAppOpen && (
          <div style={{
            position: 'absolute',
            bottom: '80px',
            right: '0',
            width: window.innerWidth <= 768 ? 'calc(100vw - 40px)' : '350px',
            maxWidth: '400px',
            height: window.innerWidth <= 768 ? '400px' : '450px',
            maxHeight: '450px',
            backgroundColor: '#f0f0f0',
            borderRadius: '12px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
            border: '1px solid #e0e0e0',
            animation: 'slideIn 0.3s ease',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
          }}>

            {/* Header - WhatsApp Style */}
            <div style={{
              backgroundColor: '#075E54',
              color: 'white',
              padding: window.innerWidth <= 768 ? '16px' : '14px',
              borderRadius: '12px 12px 0 0',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              borderBottom: '1px solid #128C7E',
              flexShrink: 0
            }}>
              <div style={{
                width: '36px',
                height: '36px',
                borderRadius: '50%',
                backgroundColor: '#25D366',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '18px'
              }}>
                🏢
              </div>
              <div style={{ flex: 1 }}>
                <div style={{
                  fontWeight: '600',
                  fontSize: window.innerWidth <= 768 ? '16px' : '15px'
                }}>
                  Maakdream Properties
                </div>
                <div style={{ fontSize: '12px', opacity: 0.9 }}>online</div>
              </div>
              <div
                style={{
                  fontSize: '18px',
                  cursor: 'pointer',
                  padding: '4px',
                  borderRadius: '50%',
                  transition: 'background-color 0.2s ease'
                }}
                onClick={() => setIsWhatsAppOpen(false)}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = 'rgba(255,255,255,0.1)';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                }}
              >
                ✕
              </div>
            </div>

            {/* Chat Messages Area */}
            <div style={{
              flex: 1,
              padding: window.innerWidth <= 768 ? '16px' : '14px',
              overflowY: 'auto',
              backgroundColor: '#e5ddd5',
              backgroundImage: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.1"%3E%3Ccircle cx="30" cy="30" r="2"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")'
            }}>
              {/* Welcome Message Bubble */}
              <div style={{
                display: 'flex',
                justifyContent: 'flex-start',
                marginBottom: '12px'
              }}>
                <div style={{
                  backgroundColor: 'white',
                  padding: window.innerWidth <= 768 ? '12px 16px' : '10px 14px',
                  borderRadius: '18px',
                  maxWidth: '85%',
                  boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                  fontSize: window.innerWidth <= 768 ? '14px' : '13px',
                  lineHeight: '1.4'
                }}>
                  Hello! 👋 How can we help you today? Please provide your details below.
                </div>
              </div>
            </div>

            {/* Form Area */}
            <div style={{
              padding: window.innerWidth <= 768 ? '16px' : '14px',
              backgroundColor: '#f0f0f0',
              borderTop: '1px solid #e0e0e0',
              borderRadius: '0 0 12px 12px',
              flexShrink: 0
            }}>
              <form onSubmit={handleWhatsAppSubmit} autoComplete="on">
                <div style={{ marginBottom: '10px' }}>
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Full Name"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    autoComplete="name"
                    style={{
                      width: '100%',
                      padding: window.innerWidth <= 768 ? '12px 16px' : '10px 14px',
                      border: '1px solid #ddd',
                      borderRadius: '20px',
                      fontSize: window.innerWidth <= 768 ? '14px' : '13px',
                      outline: 'none',
                      boxSizing: 'border-box',
                      transition: 'border-color 0.3s ease'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#25D366';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#ddd';
                    }}
                    required
                  />
                </div>
                <div style={{ marginBottom: '10px' }}>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Your Phone Number"
                    value={userPhone}
                    onChange={(e) => setUserPhone(e.target.value)}
                    autoComplete="tel"
                    style={{
                      width: '100%',
                      padding: window.innerWidth <= 768 ? '12px 16px' : '10px 14px',
                      border: '1px solid #ddd',
                      borderRadius: '20px',
                      fontSize: window.innerWidth <= 768 ? '14px' : '13px',
                      outline: 'none',
                      boxSizing: 'border-box',
                      transition: 'border-color 0.3s ease'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#25D366';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#ddd';
                    }}
                    required
                  />
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <textarea
                    name="message"
                    placeholder="Type your message here..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    autoComplete="off"
                    style={{
                      width: '100%',
                      padding: window.innerWidth <= 768 ? '12px 16px' : '10px 14px',
                      border: '1px solid #ddd',
                      borderRadius: '20px',
                      fontSize: window.innerWidth <= 768 ? '14px' : '13px',
                      minHeight: window.innerWidth <= 768 ? '60px' : '50px',
                      resize: 'none',
                      outline: 'none',
                      boxSizing: 'border-box',
                      fontFamily: 'inherit',
                      transition: 'border-color 0.3s ease'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#25D366';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#ddd';
                    }}
                    required
                  />
                </div>
                <button
                  type="submit"
                  style={{
                    width: '100%',
                    padding: window.innerWidth <= 768 ? '12px 16px' : '10px 14px',
                    backgroundColor: '#25D366',
                    color: 'white',
                    border: 'none',
                    borderRadius: '20px',
                    fontSize: window.innerWidth <= 768 ? '14px' : '13px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = '#128C7E';
                    e.target.style.transform = 'translateY(-1px)';
                    e.target.style.boxShadow = '0 4px 12px rgba(37, 211, 102, 0.4)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = '#25D366';
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = 'none';
                  }}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
                  </svg>
                  Send to WhatsApp
                </button>
              </form>
            </div>
          </div>
        )}
      </div>


    </div>
  );
}

export default App;
